/**
 * Validation Patterns & Messages
 * Các pattern regex và message validation mặc định
 */

/**
 * Regex Patterns cho validation
 */
export const VALIDATION_PATTERNS = {
    /** Số điện thoại VN: 10-11 số, bắt đầu bằng 0 */
    mobilephone: /^0[0-9]{9,10}$/,

    /** Email format */
    email: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/i,

    /** URL format */
    url: /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'()\*\+,;=.]+$/,

    /** Mã số thuế (0-20 số) */
    taxcode: /^[0-9]{0,20}$/,

    /** CMND/CCCD (12 số) */
    license: /^[0-9]{12}$/,

    /** Password mạnh: ít nhất 8 ký tự, có chữ hoa, chữ thường, số và ký tự đặc biệt */
    password: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,

    /** Số thập phân */
    decimal: /^\d*\.?,*\d*$/,

    /** Số nguyên dương */
    positiveInteger: /^[1-9]\d*$/,

    /** Số nguyên không âm */
    nonNegativeInteger: /^(0|[1-9]\d*)$/,

    /** Chỉ chữ và số */
    alphanumeric: /^[a-zA-Z0-9]*$/,
};

/**
 * Default Validation Messages
 * Các message validation mặc định (tiếng Việt)
 */
export const DEFAULT_VALIDATION_MESSAGES = {
    required: 'Trường này là bắt buộc',
    minLength: 'Tối thiểu {minLength} ký tự',
    maxLength: 'Tối đa {maxLength} ký tự',
    min: 'Giá trị tối thiểu là {min}',
    max: 'Giá trị tối đa là {max}',
    email: 'Email không đúng định dạng',
    pattern: 'Giá trị không đúng định dạng',

    // Preset validation messages
    mobilephone: 'Số điện thoại không đúng định dạng (10-11 số, bắt đầu bằng 0)',
    url: 'URL không đúng định dạng',
    taxcode: 'Mã số thuế không đúng định dạng',
    license: 'CMND/CCCD phải có đúng 12 số',
    password: 'Mật khẩu phải có ít nhất 8 ký tự, bao gồm chữ hoa, chữ thường, số và ký tự đặc biệt',
    decimal: 'Phải là số thập phân hợp lệ',
    positive: 'Phải là số lớn hơn 0',
    integer: 'Phải là số nguyên',
    codeTaken: 'Mã đã tồn tại trên hệ thống',

    // Async validation
    asyncPending: 'Đang kiểm tra...',
    asyncError: 'Lỗi khi kiểm tra',
};

/**
 * Field Type Defaults
 * Config mặc định cho từng loại field
 */
export const FIELD_TYPE_DEFAULTS = {
    text: {
        attributes: {
            autocomplete: 'off',
        },
    },
    email: {
        validation: {
            email: true,
        },
        attributes: {
            autocomplete: 'email',
            type: 'email',
        },
    },
    password: {
        attributes: {
            autocomplete: 'new-password',
            type: 'password',
        },
    },
    tel: {
        validation: {
            preset: 'mobilephone' as const,
        },
        attributes: {
            autocomplete: 'tel',
            type: 'tel',
        },
    },
    number: {
        attributes: {
            type: 'number',
        },
    },
    url: {
        validation: {
            preset: 'url' as const,
        },
        attributes: {
            autocomplete: 'url',
            type: 'url',
        },
    },
    textarea: {
        attributes: {
            rows: 3,
        },
    },
};
